<template>
  <div id="MChatRQrCode">
    <Modal v-model="QRCodeWindow" title="二维码" :styles="{'top':'60px', 'max-height': '400px', 'overflow-y': 'auto'}" :mask-closable="false">
      <table id="qrCodePrint" class="container" cellspacing="0" cellpadding="0" align="center" style="text-align:center;">
        <tbody>
          <tr><td><img :src="edit.qrcodeUrl" style="width:180px;height:180px;"/></td></tr>
        </tbody>
      </table>
      <div slot="footer">
        <a id="print" v-print="printContent" v-show="false">打印</a>
        <Button @click="QRCodeWindow = false">取消</Button>
        <Button type="primary" @click="print">打印</Button>
      </div>
    </Modal>

  </div>
</template>
<script>
import {_get} from "@/services/qrcode/mChatQrCode";
export default {
  name: "MChatRQrCode",
  data() {
    return {
      disabled:false,
      QRCodeWindow:false,
      columns : [

      ],
      edit: {
        id:"",
        qrcodeUrl:"",
      },
      printContent:{
        id:"qrCodePrint",
        preview:false,
        previewTitle:'  ',
        popTitle:'  ',
        extraHead:'<meta http-equiv="Content-Language"content="zh-cn"/>',
        previewBeforeOpenCallback(){

        },
        previewOpenCallback(){

        },
        beforeOpenCallback(vue){
          vue.printLoading=true

        },
        openCallback(vue){
          vue.printLoading=false

        },
        closeCallback(){

        },
        clickMounted(vue){
          vue.printContent.popTitle="      "
        }
      },
      init: "",
      loading: {
        form: false,
        btn: false
      },
      taskElem:[],
      taskRule: {

      },
    };
  },
  mounted() {
    this.init = Object.assign({}, this.edit);
  },
  methods: {
    get(id){
      _get({id:id}).then(res=>{
        if (res.errcode === 1 && res.data) {
          this.edit = res.data;
        }
      });
    },
    handleModal(qrcodeId) {
      this.QRCodeWindow = true;
      this.get(qrcodeId);
    },
    print(){
      this.$nextTick(()=>{
        document.getElementById('print').click();
      })
    },
  }
};
</script>

